<template>
  <div class="swiper">
    <img
      v-for="(item, index) in swiper"
      :key="index"
      :src="item"
      :class="{active:imgActive[index]}"
    >
  </div>
</template>

<script>
export default {
  name: "SwiperPlay", //序列帧
  props: {
    swiper: Array
  },
  data() {
    return {
      imgActive: []
    };
  },
  mounted() {
    this.setActive();
    this.setSwiper();
  },
  methods: {
    // 给每个item添加一个不显示的状态
    setActive() {
      this.imgActive = [];
      for (let i = 0; i < this.swiper.length; i++) {
        this.imgActive.push(false);
      }
    },
    // 改变其中一个item的状态 来显示item
    setSwiper() {
      let n = 0;
      setInterval(() => {
        this.setActive();
        this.imgActive[n] = true;
        n++;
        if (n === this.swiper.length) {
          n = 0;
        }
      }, 200);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/com.scss";
.swiper {
  @include wh(100%);
  position: relative;
  img {
    @include wh(100%);
    position: absolute;
    display: none;
  }
  img.active {
    display: block;
  }
}
</style>



